export default "__VITE_ASSET__DUcK3BIb__"